import React from "react";
import { useLocation } from "react-router";

// const location = useLocation();

const savePathToLocalStorage = () => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const location = useLocation();
  const locationUrl = location.pathname;
  window.localStorage.setItem("URL", JSON.stringify(locationUrl));
  return;
};

export { savePathToLocalStorage };
